import type { ReactElement, ReactNode } from 'react';
import { useState } from 'react';
import { toast } from 'sonner';
import { ToastItem } from './toast-item';

type DefaultToastConfig = {
  type: 'default';
  message: ReactNode;
  actionNode?: ReactElement;
};

type ConfirmToastConfig = {
  type: 'confirm';
  message: ReactNode;
};

type DestructiveToastConfig = {
  type: 'destructive';
  message: ReactNode;
};

type ToastConfig = DefaultToastConfig | ConfirmToastConfig | DestructiveToastConfig;

export const useToast = () => {
  const [toastId, setToastId] = useState<string | number | null>(null);

  const openToast = (config: ToastConfig) => {
    const id = toast.custom(() => {
      switch (config.type) {
        case 'default':
          return (
            <ToastItem.Default actionNode={config.actionNode}>{config.message}</ToastItem.Default>
          );
        case 'confirm':
          return <ToastItem.Confirm>{config.message}</ToastItem.Confirm>;
        case 'destructive':
          return <ToastItem.Destructive>{config.message}</ToastItem.Destructive>;
      }
    });

    setToastId(id);
  };

  const closeToast = () => {
    if (toastId) {
      toast.dismiss(toastId);
      setToastId(null);
    }
  };

  return {
    openToast,
    closeToast,
  };
};
